import React from 'react';

import ModelTypeConstants from 'constants/ModelTypeConstants';
import BenchlingIcon, {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';

interface LabeledFolderProps {
  className?: string;
  name: string;
  onClick?: () => void;
}

interface LabeledItemProps extends LabeledFolderProps {
  icon: BenchlingIconName;
}

/**
 * Renders a faded span with an icon and item name
 */
function LabeledItem({icon, name, onClick, className}: LabeledItemProps): JSX.Element {
  return (
    <span className={className} onClick={onClick}>
      <BenchlingIcon className="u-faded" icon={icon} />
      {` ${name}`}
    </span>
  );
}

/**
 * Renders a span with a folder icon and folder name.
 */
export default function LabeledFolder({name, onClick, className}: LabeledFolderProps): JSX.Element {
  return <LabeledItem className={className} icon={ModelTypeConstants.FOLDER} name={name} onClick={onClick} />;
}
